import constants from 'common/constants'

import {
  BULK_CSV_IMPORT,
  CONFIRM_CSV_IMPORT,
  CREATE_CSV_IMPORT_VENUES,
  DOWNLOAD_CSV_IMPORT_TEMPLATE,
  GET_CSV_IMPORT_SCHEMA,
  GET_CSV_IMPORT_TABLE_SCHEMAS,
  GET_SCHOOL_SYSTEMS,
  GET_SCHOOL_SYSTEMS_DETAILS,
  UPLOAD_CSV_IMPORT_FILE,
} from './ActionTypes/ApiActionTypes'
import {
  REDUX_GET_CSV_IMPORT_SCHEMA,
  REDUX_GET_CSV_IMPORT_TABLE_SCHEMAS,
} from './ActionTypes/ReduxActionTypes'

/* Get table schemas for CSV import */
export const getCsvImportTableSchemas = (onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_CSV_IMPORT_TABLE_SCHEMAS,
    payload: {
      apiUrl: constants.api_csv_import_table_schemas,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: reduxUpdate ? REDUX_GET_CSV_IMPORT_TABLE_SCHEMAS : '',
      onSuccess,
      onFailure,
    },
  }
}

/* Get schema for CSV import */
export const getCsvImportSchema = (onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_CSV_IMPORT_SCHEMA,
    payload: {
      apiUrl: constants.api_csv_import_schema,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: reduxUpdate ? REDUX_GET_CSV_IMPORT_SCHEMA : '',
      onSuccess,
      onFailure,
    },
  }
}

/* Upload CSV file for import */
export const uploadCsvImportFile = (formData, onSuccess, onFailure) => {
  return {
    type: UPLOAD_CSV_IMPORT_FILE,
    payload: {
      apiUrl: constants.api_csv_import_upload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'multipart/form-data',
      body: formData,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/* Confirm CSV import with mapped data */
export const confirmCsvImport = (data, onSuccess, onFailure) => {
  return {
    type: CONFIRM_CSV_IMPORT,
    payload: {
      apiUrl: constants.api_csv_import_confirm,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/* Create venues (mode 1: as many as classes; mode 2: bulk names) */
export const createCsvImportVenues = (payload, onSuccess, onFailure) => {
  return {
    type: CREATE_CSV_IMPORT_VENUES,
    payload: {
      apiUrl: constants.api_csv_import_create_venues,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: payload,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/* Bulk import manual data */
export const bulkCsvImport = (data, onSuccess, onFailure) => {
  return {
    type: BULK_CSV_IMPORT,
    payload: {
      apiUrl: constants.api_csv_import_bulk,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/* Get school systems for curriculum selection */
export const getSchoolSystems = (onSuccess, onFailure) => {
  return {
    type: GET_SCHOOL_SYSTEMS,
    payload: {
      apiUrl: constants.api_csv_import_school_systems,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/*
 * Get levels/classes details for selected school systems. `options.plainNames` asks for level
 * and grade names without the curriculum prefix (onboarding wizard, supported schools only).
 */
export const getSchoolSystemsDetails = (systems, onSuccess, onFailure, options) => {
  return {
    type: GET_SCHOOL_SYSTEMS_DETAILS,
    payload: {
      apiUrl: constants.api_csv_import_school_systems_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: options?.plainNames ? {systems, plain_names: true} : {systems},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const downloadCsvImportTemplate = (onSuccess, onFailure) => {
  return {
    type: DOWNLOAD_CSV_IMPORT_TEMPLATE,
    payload: {
      apiUrl: constants.api_csv_import_download_template,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: null,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
